export type Language = string;

export interface LanguageListModel {
  languageId: number;
  languageCode: Language;
  languageName: string;
  nativeLanguage: string;
}
